export const iconFontAwesomeHumanitarianRoad = (
	<i className="fa-solid fa-road"></i>
);
